module.exports = __webpack_public_path__ + "static/media/Short Tech Training 2022_1638555261934.47947cb1.docx";